import { render, staticRenderFns } from "./CustomerExpire.vue?vue&type=template&id=7e38d2de&scoped=true&"
import script from "./CustomerExpire.vue?vue&type=script&lang=js&"
export * from "./CustomerExpire.vue?vue&type=script&lang=js&"
import style0 from "./CustomerExpire.vue?vue&type=style&index=0&id=7e38d2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e38d2de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VRow})
